import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Header() {
    const { t } = useTranslation();


    return (
        <header id="header" className="py-[10px] shadow-[0px_0px_10px_#00000021] relative z-[100] transition-all duration-300 flex flex-col">
            <div className="py-[10px] px-[80px] flex items-center justify-between">
                <Link to={"/"}>
                    <img className="w-[115px] h-[60px]" src={require("../../assets/logo/logo.svg").default} alt="Logo" />
                </Link>

                <Link className='bg-[#E56820] py-[7px] px-5 rounded text-white font-bold' to={"https://alburoujplast.com/"}>
                    {t("Go To Website")}
                </Link>
            </div>
        </header>
    );
}